<div class="flex gap-8 flex-wrap">
  <div
    class="button button--style-white-04 button--style-white-04-bordered h-24 gap-4 padding-x-4"
  >
    Min bet: {{ jackpotService.minBet | currency : "USD" : "symbol" : "1.2-2" }}
  </div>
  <div
    class="button button--style-white-04 button--style-white-04-bordered h-24 gap-4 padding-x-4"
  >
    Max bet: {{ jackpotService.maxBet | currency : "USD" : "symbol" : "1.2-2" }}
  </div>
  <div
    class="button button--style-white-04 button--style-white-04-bordered h-24 gap-4 padding-x-4"
  >
    Min items: {{ jackpotService.minItems }}
  </div>
  <div
    class="button button--style-white-04 button--style-white-04-bordered h-24 gap-4 padding-x-4"
  >
    Max items: {{ jackpotService.maxItems }}
  </div>
</div>
<button
  class="create button button--style-yellow padding-x-12 h-40"
  (click)="openJoinGame()"
>
  Join Game
</button>
